import type { FormatOptionLabelMeta } from 'react-select';

type HintOption = { label: string; value: string };

/**
 * [MCV-1761] A muted parse hint beside an option in the open menu, e.g. "CV  Can be parsed". The
 * selected value keeps its plain label.
 *
 * [MCV-1810] `stacked` puts the hint on a second line under the label instead of beside it: the
 * per-file File Type select in the Add Document list is narrow, and a side-by-side hint would
 * wrap or cut off. The full-width selects (File Category, and File Type when editing) keep the
 * single line.
 */
export const withParseHint =
  (hints: Record<string, string>, layout: 'inline' | 'stacked' = 'inline') =>
  (option: HintOption, { context }: FormatOptionLabelMeta<HintOption>) => {
    const hint = hints[option.value];
    if (context !== 'menu' || !hint) return option.label;
    return layout === 'stacked' ? (
      <span className="flex flex-col pr-2">
        <span>{option.label}</span>
        <span className="text-xs text-grey-300">{hint}</span>
      </span>
    ) : (
      <span className="flex items-baseline justify-between gap-3 pr-2">
        <span>{option.label}</span>
        <span className="text-xs text-grey-300">{hint}</span>
      </span>
    );
  };
